import styles from "./index.module.less";
import { useState } from "react";
import P1Content from "@/components/P1Content";
import data from "../data";
import NewsList from "@/pages/news/components/NewsList";
import banner from "./imgs/banner.png";
const caseList = data.caseList;
const PAGE_SIZE = 12;
const MobileCooperationCases = () => {
  const [page, setPage] = useState(1);
  return (
    <div className={styles.page}>
      <div className={styles.p1}>
        <P1Content
          title="伙伴案例"
          subtitle="聚焦实践，引领创新"
          showBtn={false}
          style={{
            backgroundImage: `url(${banner})`,
          }}
        />
      </div>
      <div className={styles.p2}>
        <NewsList list={caseList.slice(0, page * PAGE_SIZE)} />
        <div
          className={styles.more_btn}
          onClick={() => {
            if (page * PAGE_SIZE >= caseList.length) {
              return;
            }
            setPage((prev) => prev + 1);
          }}
        >
          MORE
        </div>
      </div>
    </div>
  );
};
export default MobileCooperationCases;
